export default {
  cart: {
    saleSavingsAmount: 'Du sparst {amount} bei der Buchung auf konfetti',
    voucherSavings: 'Du sparst {amount} mit dem Code {code}',
    discount: 'Rabatt',
    items: 'Artikel',
    giftcardTitle: 'Geschenkgutschein',
    giftbox: {
      title: 'Geschenkkarte inkl. Versand',
      price: 'nur {price}',
      addButtonLabel: 'Dazu',
      addedButtonLabel: 'Entfernen',
    },
    shippingTotal: 'Versandkosten',
    shippingTotalSubline: 'inkl. MwSt., zzgl. Versandkosten',
    grandTotal: 'Gesamtsumme',
    removeGiftbox: 'Geschenkbox entfernen',
    checkoutButton: 'Zur Kasse',
    continueShopping: 'Weiter einkaufen',
    multiDateCard: {
      title: 'Your class has {count} dates',
    },
    notEnoughTicketsError: {
      title: 'Error',
      description:
        'Verfügbarkeit an diesem Termin begrenzt. Es können keine weiteren Tickets hinzugefügt werden.',
    },
    emptyCart: {
      title: 'Ups! Der Warenkorb ist leer',
      description:
        'Sieht so aus, als hättest Du noch keine Artikel in den Warenkorb gelegt.',
    },
    removeItem: {
      message: 'Artikel wurde entfernt',
      cancel: 'Rückgängig machen',
      label: 'Artikel entfernen',
    },
    itemRemoved: {
      title: 'Artikel entfernt',
      message: ':Der Artikel wurde erfolgreich entfernt.',
    },
    validation: {
      modalTitle: 'Dein Warenkorb wurde aktualisiert',
      goToEvent: 'Zur Kursseite',
    },
    giftcard: 'Gutschein',
    giftcardAddons: {
      PDF: {
        title: 'Gutschein zum Selbstausdrucken',
        description:
          'Digitale Geschenkkarte, die Du immer direkt als PDF per E-Mail erhältst',
      },
      CARD: {
        title: 'Geschenkkarte per Post',
        description:
          'Hochwertige Karte im Umschlag (2-5 Werktage Versand) - inkl. PDF per E-Mail',
      },
      BOX: {
        title: 'Geschenkbox per Post',
        description:
          'Premium-Box inkl. Gutscheinkarte (2-5 Werktage Versand) - inkl. PDF per E-Mail',
      },
    },
    giftcardSplit: {
      label: 'Einen separaten Gutschein je Ticket erhalten',
    },

    cartItem: {
      priceUpdated: 'Dieser Artikel hatte Preisaktualisierungen.',
    },

    itemsInfo: {
      title: 'Gut zu wissen',
      iconsLabels: {
        giftcard: {
          first: 'Gutschein zum Selbstausdrucken',
          second: 'Einlösbar für über {eventCount} Kurse',
          third: 'Gültig für drei Jahre ab Kauf',
        },
        normalTicket: {
          first: 'Tickets werden via E-Mail versendet',
          second: 'Tickets sind übertragbar',
          third: 'Bei Fragen melde Dich jederzeit',
        },
        various: {
          first: 'Gutschein zum Selbstausdrucken',
          second: 'Tickets sind übertragbar',
          third: 'Bei Fragen melde Dich jederzeit',
        },
      },
    },
  },
}
